import React from "react";

import { Row, Col } from "antd";
import { Margin } from "styled-components-spacing";
import Center from "react-center";
import { PlusOutlined } from "@ant-design/icons";
import { Player } from "video-react";
import videoPoster from "../../Imgs/HomePage/videoPoster.jpg";

// CSS Files
import "../../../../node_modules/video-react/dist/video-react.css";
import "../../Fonts/Fonts.css";
import "../../Statics/Common/FontStyle.css";
import "../../Statics/HomePage/Introduction.css";

import sandoghKeshavarzi from "../../Imgs/HomePage/Sandogh/2.png";
import parvane from "../../Imgs/HomePage/parvane-arzyabi.jpeg";

const Khesarat = (props) => {
  return props.size === "laptopdesktop" ? (
    <div style={{ backgroundColor: "#f6f6f6" }}>
      <Row>
        <Col span={3}></Col>
        <Col span={8}>
          <Margin top={5}></Margin>
          <div className="videoDashBorder" style={{marginTop:"100px"}}>
            <img className="videoStyle" src={parvane} />
          </div>
          <Margin bottom={5}></Margin>
        </Col>
        <Col span={1}></Col>
        <Col span={9}>
          <Margin top={5}></Margin>
          <h5
            style={{
              fontFamily: "IRANSans",
              color: "#ed1c24",
              marginTop: "-10px",
              textAlign: "right",
            }}
          >
            <strong>پروانه ارزیابی خسارت بیمه‌ای</strong>
          </h5>
          <Margin top={3}></Margin>
          <p className="textParagraph">
          ریس کل بیمه مرکزی 
پروانه فعالیت ارزیابی خسارت در تمام رشته های بیمه (جنرال) برای سه سال دیگر برای ایرانیان پوشش در سراسر کشور تمدید کرد.
شورای عالی بیمه در سال ۱۳۸۲ براساس بند ۵ ماده ۱۷ قانون تأسیس بیمه مرکزی و بیمه‌گری ، جهت هدایت امر بیمه ، فعالیت شرکت های بیمه و حفظ حقوق بیمه‌گذاران و زیان‌دیدگان ، آیین‌نامه شماره ۵۰ اعطای پروانه و نحوه فعالیت شرکت های ارزیابی خسارت بیمه‌ای را تصویب نمود که پس از حدود ۱۰ سال فاصله طولانی در فرایند قانون‌گذاری شورای عالی بیمه ، در سال ۱۳۹۲ ، آیین‌نامه شماره ۸۵ را با تغییرات اساسی و لازم ، جایگزین آیین‌نامه قبلی نمود. در اجرای مصوبات بیمه مرکزی جمهوری اسلامی ایران مبنی‌ بر برون ‌سپاری خدمات بیمه‌ای ، هیئت مؤسسین شرکت سهامی ارزیابی خسارت بیمه‌ای ایرانیان پوشش ، Insurance Loss Adjuster ، به‌عنوان نخستین شرکت ارزیابی خسارت بیمه ای دارای پروانه فعالیت از بیمه مرکزی جمهوری اسلامی ایران با کد ۲۰ تأسیس گردید. این شرکت ، به سبب بهره‌مندی از تجربه و تخصص فنی کارشناسان خود با عنوان خدمتگزاران بنام ، سخت‌کوش و وفادار در صنعت بیمه ، با افتخار ، خدمات مطمئن و ارزنده‌ای به بیمه‌گران و بیمه‌گذاران محترم در سراسر کشور ارائه می‌دهد.
          </p>
          <Margin bottom={3}></Margin>
        </Col>
        <Col span={4}></Col>
      </Row>
    </div>
  ) : props.size === "tablet" ? (
    <div style={{ backgroundColor: "#f6f6f6" }}>
      <Row>
        <Col span={1}></Col>
        <Col span={22}>
          <Margin top={4}>
            <p
              style={{
                fontFamily: "IRANSans",
                color: "#ed1c24",
                direction: "rtl",
                textAlign: "right",
                fontSize: "1.05em",
              }}
            >
            <strong>پروانه ارزیابی خسارت بیمه‌ای</strong>
            </p>
          </Margin>
        </Col>
        <Col span={1}></Col>
      </Row>

      <Row>
        <Col span={2}></Col>
        <Col span={20}>
          <p className="textParagraphTablet">
          ریس کل بیمه مرکزی 
پروانه فعالیت ارزیابی خسارت در تمام رشته های بیمه (جنرال) برای سه سال دیگر برای ایرانیان پوشش در سراسر کشور تمدید کرد.
شورای عالی بیمه در سال ۱۳۸۲ براساس بند ۵ ماده ۱۷ قانون تأسیس بیمه مرکزی و بیمه‌گری ، جهت هدایت امر بیمه ، فعالیت شرکت های بیمه و حفظ حقوق بیمه‌گذاران و زیان‌دیدگان ، آیین‌نامه شماره ۵۰ اعطای پروانه و نحوه فعالیت شرکت های ارزیابی خسارت بیمه‌ای را تصویب نمود که پس از حدود ۱۰ سال فاصله طولانی در فرایند قانون‌گذاری شورای عالی بیمه ، در سال ۱۳۹۲ ، آیین‌نامه شماره ۸۵ را با تغییرات اساسی و لازم ، جایگزین آیین‌نامه قبلی نمود. در اجرای مصوبات بیمه مرکزی جمهوری اسلامی ایران مبنی‌ بر برون ‌سپاری خدمات بیمه‌ای ، هیئت مؤسسین شرکت سهامی ارزیابی خسارت بیمه‌ای ایرانیان پوشش ، Insurance Loss Adjuster ، به‌عنوان نخستین شرکت ارزیابی خسارت بیمه ای دارای پروانه فعالیت از بیمه مرکزی جمهوری اسلامی ایران با کد ۲۰ تأسیس گردید. این شرکت ، به سبب بهره‌مندی از تجربه و تخصص فنی کارشناسان خود با عنوان خدمتگزاران بنام ، سخت‌کوش و وفادار در صنعت بیمه ، با افتخار ، خدمات مطمئن و ارزنده‌ای به بیمه‌گران و بیمه‌گذاران محترم در سراسر کشور ارائه می‌دهد.
          </p>
        </Col>
        <Col span={2}></Col>
      </Row>
      <Row>
        <Col span={3}></Col>
        <Col span={18}>
          <div className="videoDashBorder">
            <img className="videoStyle" src={parvane} />
          </div>
          <Margin bottom={4}></Margin>
        </Col>
        <Col span={3}></Col>
      </Row>
    </div>
  ) : (
    <div style={{ backgroundColor: "#f6f6f6" }}>
      <Row>
        <Col span={1}></Col>
        <Col span={22}>
          <Margin top={4}></Margin>

          <p
            style={{
              fontFamily: "IRANSans",
              color: "#ed1c24",
              direction: "rtl",
              textAlign: "right",
              fontSize: ".95em",
              marginTop: "-10px",
            }}
          >
            <strong>پروانه ارزیابی خسارت بیمه‌ای</strong>
            </p>
        </Col>
        <Col span={1}></Col>
      </Row>
      <Row>
        <Col span={2}></Col>
        <Col span={20}>
          <p className="textParagraphMobile">
          ریس کل بیمه مرکزی 
پروانه فعالیت ارزیابی خسارت در تمام رشته های بیمه (جنرال) برای سه سال دیگر برای ایرانیان پوشش در سراسر کشور تمدید کرد.
شورای عالی بیمه در سال ۱۳۸۲ براساس بند ۵ ماده ۱۷ قانون تأسیس بیمه مرکزی و بیمه‌گری ، جهت هدایت امر بیمه ، فعالیت شرکت های بیمه و حفظ حقوق بیمه‌گذاران و زیان‌دیدگان ، آیین‌نامه شماره ۵۰ اعطای پروانه و نحوه فعالیت شرکت های ارزیابی خسارت بیمه‌ای را تصویب نمود که پس از حدود ۱۰ سال فاصله طولانی در فرایند قانون‌گذاری شورای عالی بیمه ، در سال ۱۳۹۲ ، آیین‌نامه شماره ۸۵ را با تغییرات اساسی و لازم ، جایگزین آیین‌نامه قبلی نمود. در اجرای مصوبات بیمه مرکزی جمهوری اسلامی ایران مبنی‌ بر برون ‌سپاری خدمات بیمه‌ای ، هیئت مؤسسین شرکت سهامی ارزیابی خسارت بیمه‌ای ایرانیان پوشش ، Insurance Loss Adjuster ، به‌عنوان نخستین شرکت ارزیابی خسارت بیمه ای دارای پروانه فعالیت از بیمه مرکزی جمهوری اسلامی ایران با کد ۲۰ تأسیس گردید. این شرکت ، به سبب بهره‌مندی از تجربه و تخصص فنی کارشناسان خود با عنوان خدمتگزاران بنام ، سخت‌کوش و وفادار در صنعت بیمه ، با افتخار ، خدمات مطمئن و ارزنده‌ای به بیمه‌گران و بیمه‌گذاران محترم در سراسر کشور ارائه می‌دهد.
          </p>
        </Col>
        <Col span={2}></Col>
      </Row>
      <Row>
        <Col span={2}></Col>
        <Col span={20}>
          <Margin top={3}></Margin>

          <div className="videoDashBorder">
            <img className="videoStyle" src={parvane} />
          </div>
          <Margin bottom={4}></Margin>
        </Col>
        <Col span={2}></Col>
      </Row>
    </div>
  );
};

export default Khesarat;
